var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 13H13M8.18961 2.54114C8.18961 2.54114 8.18961 3.63089 9.27936 4.72064C10.3691 5.81039 11.4589 5.81039 11.4589 5.81039M3.87975 10.992L6.16823 10.6651C6.49833 10.618 6.80424 10.465 7.04003 10.2292L12.5486 4.72064C13.1505 4.11879 13.1505 3.14299 12.5486 2.54114L11.4589 1.45139C10.857 0.849537 9.88121 0.849537 9.27936 1.45139L3.77078 6.95997C3.53499 7.19576 3.38203 7.50167 3.33488 7.83177L3.00795 10.1202C2.9353 10.6288 3.3712 11.0647 3.87975 10.992Z",
    stroke: "#868687",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditList);
export default __webpack_public_path__ + "static/media/edit_list.76785f8f372ea5145ca6530bafaeb8a2.svg";
export { ForwardRef as ReactComponent };